import PropTypes from 'prop-types';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useSelector } from 'react-redux';
import { postToContainer } from '../../global-utils/HrefUtils';
import { useDispatchVmEventList } from '../../global-utils';
import { stylesPropType, vmPropTypes, componentsPropType } from '../../global-prop-types';
import ComponentsArrRenderer from '../core/ComponentsArrRenderer';
import vmFunctions from '../../global-utils/vmFunctions';
import { dataInsightTrack } from '../../modules/data-insight/model/utils';
// import storageAndCookie from '../../global-utils/storage-and-cookies';

const options = ['_blank', '_parent', '_self', '_top'];

const ExternalHref = (props) => {
  const dispatchVmEventList = useDispatchVmEventList();
  const {
    href,
    rel,
    styles,
    variant,
    disablePostToContainer,
    vmOnClick,
    target,
    ariaLabel,
    hideAria,
    shouldTrack,
    ...restProps
  } = props;

  const matomoModule = useSelector((state) => state?.appState?.settings?.modules?.matomoModule);
  const { trackEvent } = useMatomo();

  if (!href) return null;

  const handleClick = (e) => {
    if (matomoModule?.settings?.isActive) {
      trackEvent({ category: href, action: 'click-event-external' }); // Matomo
    }
    if (shouldTrack) {  
      dataInsightTrack({
        sourceApplicationAction: 'vmx-linkbox-link',
        sourceApplication: 'vmx',
        sourceApplicationContext: document.title || null,
        entityId: href
      });
    }
    if (!disablePostToContainer) postToContainer(e, href);
    const dataBank = { vmFunctions, props };
    dispatchVmEventList(vmOnClick, dataBank);
  };

  const validateTarget = () => {
    if (!options.includes(target)) {
      return '_blank';
    }
    return target;
  };

  return (
    <a
      href={href}
      target={validateTarget()}
      {...(rel && { rel })}
      className={`externalHref-wrapper ${variant || ''}`}
      style={styles?.wrapper}
      onClick={handleClick}
      {...(!hideAria && ariaLabel ? { 'aria-label': ariaLabel } : {})}
      {...(hideAria ? { 'aria-hidden': 'true', tabIndex: -1 } : {})}
    >
      <ComponentsArrRenderer {...restProps} />
    </a>
  );
};

ExternalHref.propTypes = {
  variant: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.oneOf(options),
  href: PropTypes.string,
  components: componentsPropType,
  styles: stylesPropType,
  disablePostToContainer: PropTypes.bool,
  vmOnClick: PropTypes.array,
  hideAria: PropTypes.bool,
  ariaLabel: PropTypes.string,
  shouldTrack: PropTypes.bool
};

ExternalHref.defaultProps = {
  variant: '',
  target: '_blank',
  rel: 'noreferrer',
  href: '',
  disablePostToContainer: false,
  components: [],
  styles: { wrapper: {} },
  ariaLabel: 'External Link',
  hideAria: false,
  shouldTrack: true
};

ExternalHref.vmPreview = {
  href: '/',
  components: [
    {
      componentName: 'JmeText',
      text: 'External Href Example Text'
    }
  ]
};

ExternalHref.vmPropTypes = {
  variant: vmPropTypes.className,
  target: vmPropTypes.string,
  rel: vmPropTypes.string,
  href: vmPropTypes.url,
  components: vmPropTypes.components,
  shouldTrack: vmPropTypes.boolean,
  styles: { wrapper: vmPropTypes.styles },
  disablePostToContainer: vmPropTypes.boolean,
  vmOnClick: vmPropTypes.array,
  ariaLabel: vmPropTypes.string,
  hideAria: vmPropTypes.boolean
};

export default ExternalHref;
